import React, { Fragment, useEffect, useState } from 'react';
import { Trans } from '@common/i18n/trans';
import { useFormContext } from 'react-hook-form';
import { Button } from '@common/ui/buttons/button';
import { useTrans } from '@common/i18n/use-trans';
import { DialogTrigger } from '@common/ui/overlays/dialog/dialog-trigger';
import { downloadFile } from '@app_modules/document-requests/reports/requests/use-download-bsa-report';
import { DownloadIcon } from '@common/icons/material/Download';
import { useAuth } from '@common/auth/use-auth';
import { useDownloadMdUwMyLoan } from '@app_modules/loan-applications/step5/requests/use-download-md-uw-my-loan';
import { UploadAppendDialog } from '@app_modules/loan-applications/step5/uw-my-loan-upload-append';
import { AddSourceDialog } from './uw-source-upload-add';
import { RowFileItem } from './uw-row-file-item';
import { AppendSourceDialog } from './uw-source-upload-append';
import { AddIcon } from '@common/icons/material/Add';
import { getCookie, setCookie } from 'react-use-cookie';

interface RowUwProps {
  report_id: any;
  item: any;
  onSelectedFileIdsChange?: (pidx: number, selectedFileIds: number[]) => void;
  onSelectedIdChange: (id: string) => void;
  updateSuggestedPrompts: any;
}

export function SourceRowUw({
  report_id,
  item,
  // uploadFileItems,
  onSelectedFileIdsChange,
  onSelectedIdChange,
  updateSuggestedPrompts,
}: RowUwProps) {
  const {user} = useAuth();
  const user_id = user?.id;

  const sources = getCookie(`demo-uw-sources`);
  const [fileItems, setFileItems] = useState<any[]>(item.files ? item.files : (sources ? JSON.parse(sources) : []));
  const [reportId, setReportId] = useState<string|number>(report_id);

  const addFiles = (report_id: string, files: any[]) => {
      setReportId(report_id);
      setCookie(`demo-uw-report_id`, report_id);
      setFileItems((prevFileItems) => [...prevFileItems, ...files]);
      onSelectedIdChange(report_id);
  };

  const appendFiles = (files: any[]) => {
    setFileItems((prevFileItems) => [...prevFileItems, ...files]);
  };

  useEffect(() => {
    setFileItems(fileItems);
    setCookie(`demo-uw-sources`, JSON.stringify(fileItems));
  }, [fileItems]);

  const downloadMd = useDownloadMdUwMyLoan();
  const [selectedFileIds, setSelectedFileIds] = useState<number[]>([]); // Default to empty
  
  useEffect(() => {
    if (item.files) {
      const files = item.files;//Object.values(item.sheet_names);
      // Only include sheets where check is true in selectedFileIds
      const initialSelected = files
        .filter((file: any) => file.check === true)
        .map((file: any) => file.file_id);
      setSelectedFileIds(initialSelected);
    }
  }, [item]);

  useEffect(() => {
    if (onSelectedFileIdsChange) {
      onSelectedFileIdsChange(1, selectedFileIds);
    }
  }, [selectedFileIds, 1, onSelectedFileIdsChange]);

  const removeOldFile = (file_id: number) => {
    setFileItems((prevFileItems) => prevFileItems.filter((item) => item.file_id !== file_id));
  };

  type LoanProgramsMap = { [file_id: string]: string };
  const updateFileItemsWithPrograms = (
    newLoanProgramsMap: LoanProgramsMap
  ) => {
    
    // Use the functional update form of the state setter
    setFileItems((prevFileItems: any[]): any[] => {
      
      // Map over the previous state array
      return prevFileItems.map((item: any) => {
        const loanProgram = newLoanProgramsMap[item.file_id];
  
        // Check if a program exists for the current file_id
        if (loanProgram) {
          // If the program is found, return a NEW object with the updated field.
          // The spread operator (...) ensures you copy all other existing fields.
          return {
            ...item,
            loan_program: loanProgram,
          };
        }
        
        // If no update is needed, return the original item unchanged
        return item;
      });
    });
  };

  useEffect(() => {
    window.Echo.channel('demo-loan-program-uw').listen('.update', (e: any) => {
      if (e.data[reportId] != undefined) {
        const data = e.data[reportId];
        const loan_programs = data['loan_programs'];
        // const reportId = item.report_id;
        loan_programs.map((loanProgram: any, index: number) => {
            updateFileItemsWithPrograms(loanProgram);
        });
        if (data['suggested_prompts']) {
          updateSuggestedPrompts(data['suggested_prompts']);
          setCookie(`demo-uw-suggested-prompts`, JSON.stringify(data['suggested_prompts']));
        }

        if (data['file_prompts']) {
          const file_prompts = data['file_prompts'];
          file_prompts.map((item: any, index: number) => {
            setCookie(`demo-uw-sources-`+item['file_id'], JSON.stringify(item['suggested_prompts']));
          });
        }
      }
    });
  }, [reportId])

  return (
    <>
    <Fragment>
      {reportId && fileItems.length ? (<>
        <DialogTrigger type="modal">
          <Button size="md" variant="outline" color="orange" className="mr-10 w-full">
            <Trans message="Append Source" />
          </Button>
          <AppendSourceDialog report_id={reportId} appendFiles={appendFiles} />
        </DialogTrigger>
      </>):(<>
        <DialogTrigger type="modal">
          <Button size="md" variant="outline" color="orange" className="mr-10 w-full" startIcon={<AddIcon/>}>
            <Trans message="Add Source" />
          </Button>
          <AddSourceDialog addFiles={addFiles} />
        </DialogTrigger>
      </>)}
    </Fragment>
    {fileItems?.map((fileItem: any, index: number) => (
      <RowFileItem
        report_id={reportId}
        key={`file-${index}`}
        index={index}
        file_item={fileItem}
        selectedFileIds={selectedFileIds}
        setSelectedFileIds={setSelectedFileIds}
        removeFile={removeOldFile}
      />
    ))}
    </>
  );
}